module.exports = __webpack_public_path__ + "static/media/mealhop.1dfc6e71.png";